/* eslint-disable max-len */
import React from 'react'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { ErrorBoundary } from '../../../../../components/common/ErrorBoundary'
import { ViewBase } from '../../../../../components/common/ViewBase'
import { ManagementPartner } from '../../../../../components/society/ManagementPartner/management_partner'
import { ManagementPartnerContactBase } from '../../../../../components/society/ManagementPartner/ManagementPartnerContactBase'
import { ManagementPartnerContactCard } from '../../../../../components/society/ManagementPartner/ManagementPartnerContactCard'
import { useCurrentSociety } from '../../../../../hooks/useCurrentSociety'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../../../navigation/reverseDocumentTitle'

export const SamfalligheternaGuidanceView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  useDocumentTitle(
    reverseDocumentTitle('management:samfalligheterna-guidance', {
      '{{ societyName }}': society?.name,
    })
  )

  const partner = ManagementPartner.VILLAAGARNA

  return (
    <ErrorBoundary>
      <ViewBase
        title={translate('samfalligheterna.samfalligheternaGuidanceView.title')}
      >
        <ManagementPartnerContactBase
          partner={partner}
          description={translate(
            'samfalligheterna.samfalligheternaGuidanceView.guidanceDescription'
          )}
        >
          <ManagementPartnerContactCard
            partner={partner}
            text={translate(
              'samfalligheterna.samfalligheternaGuidanceView.guidanceText'
            )}
          />
        </ManagementPartnerContactBase>
      </ViewBase>
    </ErrorBoundary>
  )
}
